import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]
  
  connect() {
    // Prevent scrolling on the background when modal is open
    document.body.style.overflow = 'hidden'
  }
  
  disconnect() {
    // Restore scrolling when modal is closed
    document.body.style.overflow = 'auto'
  }
}
